import Utils from "../utils/Utils";

const getAuth = ({ jwt, Authorization } = {}) => jwt || Authorization || "";

const addParam = (params, key, value) => {
  if (value !== undefined && value !== null && value !== "") {
    params.append(key, value);
  }
};

const vendorMenuController = {
  addCategory: ({ Authorization, companyId, companyID, jwt, request } = {}) => {
    const params = new URLSearchParams();

    addParam(params, "companyId", companyId || companyID);

    return Utils.controller(
      "api/vendor/menu/v1/categories",
      request,
      "POST",
      params.toString(),
      true,
      getAuth({ jwt, Authorization }),
      true,
    );
  },

  getCategories: ({
    Authorization,
    companyId,
    companyID,
    includeItems = false,
    jwt,
  } = {}) => {
    const params = new URLSearchParams();

    addParam(params, "companyId", companyId || companyID);
    addParam(params, "includeItems", includeItems);

    return Utils.controller(
      "api/vendor/menu/v1/categories",
      "",
      "GET",
      params.toString(),
      true,
      getAuth({ jwt, Authorization }),
      true,
    );
  },

  getMenuCategories: (request = {}) =>
    vendorMenuController.getCategories(request),

  getItems: ({
    Authorization,
    active,
    categoryId,
    companyId,
    outOfStock,
    page,
    search,
    size,
    sortBy,
    sortDirection,
  } = {}) => {
    const params = new URLSearchParams();
    addParam(params, "active", active);
    addParam(params, "categoryId", categoryId);
    addParam(params, "companyId", companyId);
    addParam(params, "outOfStock", outOfStock);
    addParam(params, "page", page);
    addParam(params, "search", search);
    addParam(params, "size", size);
    addParam(params, "sortBy", sortBy);
    addParam(params, "sortDirection", sortDirection);

    return Utils.controller(
      "api/vendor/menu/v1/items",
      "",
      "GET",
      params.toString(),
      true,
      Authorization,
      true,
    );
  },

  getItemDetails: ({ Authorization, request, jwt } = {}) => {
    return Utils.controller(
      "api/vendor/menu/v1/item/details",
      request,
      "POST",
      "",
      true,
      getAuth({ jwt, Authorization }),
      true,
    );
  },

  getCompanyProductSection: ({
    Authorization,
    companyId,
    companyID,
    jwt,
    productId,
    productID,
  } = {}) => {
    const params = new URLSearchParams();

    addParam(params, "companyId", companyId || companyID);
    addParam(params, "productId", productId || productID);

    return Utils.controller(
      "api/vendor/menu/v1/company-product-section",
      "",
      "GET",
      params.toString(),
      true,
      getAuth({ jwt, Authorization }),
      true,
    );
  },

  updateItemActive: ({
    active,
    Authorization,
    companyId,
    companyID,
    itemId,
    jwt,
  } = {}) => {
    const params = new URLSearchParams();

    addParam(params, "active", active);
    addParam(params, "companyId", companyId || companyID);
    addParam(params, "itemId", itemId);

    return Utils.controller(
      "api/vendor/menu/v1/item/active",
      "",
      "PUT",
      params.toString(),
      true,
      getAuth({ jwt, Authorization }),
      true,
    );
  },

  saveItem: ({ Authorization, companyId, itemId, request, jwt } = {}) => {
    const params = new URLSearchParams();
    addParam(params, "companyId", companyId || request?.companyId);
    addParam(params, "itemId", itemId);

    return Utils.controller(
      "api/vendor/menu/v1/item",
      request,
      "PUT",
      params.toString(),
      true,
      getAuth({ jwt, Authorization }),
      true,
    );
  },

  saveAddonItem: ({
    addonSectionId,
    addonSectionID,
    Authorization,
    companyId,
    companyID,
    jwt,
    request,
  } = {}) => {
    const params = new URLSearchParams();

    addParam(params, "addonSectionId", addonSectionId || addonSectionID);
    addParam(params, "companyId", companyId || companyID);

    return Utils.controller(
      "api/vendor/menu/v1/addon-item",
      request,
      "POST",
      params.toString(),
      true,
      getAuth({ jwt, Authorization }),
      true,
    );
  },

  saveAddonSection: ({
    Authorization,
    companyId,
    companyID,
    jwt,
    productId,
    productID,
    request,
  } = {}) => {
    const params = new URLSearchParams();

    addParam(params, "companyId", companyId || companyID);
    addParam(params, "productId", productId || productID);

    return Utils.controller(
      "api/vendor/menu/v1/addon-section",
      request,
      "POST",
      params.toString(),
      true,
      getAuth({ jwt, Authorization }),
      true,
    );
  },

  deleteItem: ({ Authorization, companyId, companyID, itemId, jwt } = {}) => {
    const params = new URLSearchParams();

    addParam(params, "companyId", companyId || companyID);
    addParam(params, "itemId", itemId);

    return Utils.controller(
      "api/vendor/menu/v1/item",
      "",
      "DELETE",
      params.toString(),
      true,
      getAuth({ jwt, Authorization }),
      true,
    );
  },

  deleteAddonItem: ({
    addonItemId,
    addonItemID,
    Authorization,
    companyId,
    companyID,
    jwt,
  } = {}) => {
    const params = new URLSearchParams();

    addParam(params, "addonItemId", addonItemId || addonItemID);
    addParam(params, "companyId", companyId || companyID);

    return Utils.controller(
      "api/vendor/menu/v1/addon-item",
      "",
      "DELETE",
      params.toString(),
      true,
      getAuth({ jwt, Authorization }),
      true,
    );
  },

  deleteAddonSection: ({
    addonSectionId,
    addonSectionID,
    Authorization,
    companyId,
    companyID,
    jwt,
  } = {}) => {
    const params = new URLSearchParams();

    addParam(params, "addonSectionId", addonSectionId || addonSectionID);
    addParam(params, "companyId", companyId || companyID);

    return Utils.controller(
      "api/vendor/menu/v1/addon-section",
      "",
      "DELETE",
      params.toString(),
      true,
      getAuth({ jwt, Authorization }),
      true,
    );
  },

  saveCategory: ({ Authorization, companyId, jwt, request } = {}) => {
    const params = new URLSearchParams();

    addParam(params, "companyId", companyId);

    return Utils.controller(
      "api/vendor/menu/v1/category",
      request,
      "PUT",
      params.toString(),
      true,
      getAuth({ jwt, Authorization }),
      true,
    );
  },

  deleteCategory: ({
    Authorization,
    categoryId,
    companyId,
    companyID,
    jwt,
  } = {}) => {
    const params = new URLSearchParams();

    addParam(params, "categoryId", categoryId);
    addParam(params, "companyId", companyId || companyID);

    return Utils.controller(
      "api/vendor/menu/v1/category",
      undefined,
      "DELETE",
      params.toString(),
      true,
      getAuth({ jwt, Authorization }),
      true,
    );
  },
  importFile: ({ Authorization, companyId, file } = {}) => {
    const requestBody = new FormData();
    requestBody.append("companyId", companyId);
    requestBody.append("file", file);
    return Utils.controller(
      "api/product/v1/bulkUpdate/import",
      requestBody,
      "POST",
      "",
      true,
      Authorization,
      true,
    );
  },
  ExportFile: ({ Authorization, request } = {}) => {
    return Utils.controller(
      "api/product/v1/bulkUpdate/export",
      request,
      "POST",
      "",
      true,
      Authorization,
      true,
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/octet-stream, text/csv, application/json",
      "blob",
    );
  },
  OutOfStock: ({ Authorization, companyId, itemId, outOfStock } = {}) => {
    return Utils.controller(
      "api/vendor/menu/v1/item/out-of-stock",
      "",
      "PUT",
      `companyId=${companyId}&itemId=${itemId}&outOfStock=${outOfStock}`,
      true,
      Authorization,
      true,
    );
  },
};

export default vendorMenuController;
